<template>
	<div ref="editorElem" style="text-align:left;height: 100%;"></div>
</template>

<script>
import E from 'wangeditor'
export default {
  name: 'Editor',
  props:{
  	html:{
  		type:String,
  		required:true
  	}
  },
  data() {
    return {
      editor: null,
      editorContent:''
    };
  },
  mounted() {
    this.editor = new E(this.$refs.editorElem);
    this.editor.config.onchange = (newHtml) => {
	    // 监听内容变化的事件
	    this.$emit('send-html', newHtml);
	}
    
    this.editor.create(); // 创建编辑器
    this.editor.txt.clear();
    this.editor.txt.html(this.html);
   
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy(); // 组件销毁时，也销毁编辑器实例
      this.editor = null;
    }
  }
}
</script>

<style>
.w-e-text-container{
	height: 450px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Editor.vue